import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

/** Account tab — now shows a subtle delete account link instead of inline danger zone */
const SettingsAccount: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="settings-section">
      <h2 className="settings-section-title">{t('settings.account', 'Account')}</h2>

      {/* Delete Account Link */}
      <div className="delete-account-link-section">
        <button
          type="button"
          className="delete-account-link-card"
          onClick={() => navigate('/settings/delete-account')}
        >
          <div className="delete-account-link-left">
            <div className="delete-account-link-icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                aria-hidden="true"
              >
                <title>Delete Account</title>
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </div>
            <div className="delete-account-link-text">
              <h3>{t('settings.deleteAccount.title', 'Delete Account')}</h3>
              <p>
                {t(
                  'settings.deleteAccount.linkDescription',
                  'Permanently delete your account and all associated data',
                )}
              </p>
            </div>
          </div>
          <svg
            className="delete-account-link-arrow"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden="true"
          >
            <title>Go</title>
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default SettingsAccount;
